export enum ActiveTabChartEnum {
  LAP_TRACK = 'LAP_TRACK',
  LEFT_ON_TABLE = 'LEFT_ON_TABLE',
  BEST_WORST = 'BEST_WORST',
}
